<template>
	<div class="tab--content" :data-tab-panel="this.uuid" role="tabpanel">
		<h3 class="h2" v-if="$slots.title">
			<slot name="title"></slot>
		</h3>

		<div class="form__content" v-if="$slots.content">
			<slot></slot>
		</div>

		<slot name="buttonContainer"></slot>
	</div>
</template>

<script>
export default {
	props: {
		uuid: {
			type: String,
			required: true,
		},
	},
};
</script>
